import React from 'react';
import UseScreenSize from '@/hooks/UseScreenSize';

import UseMyClasses from '../my-classes/UseMyClasses';
import MyClassesViewDesktop from '../my-classes/MyClassesViewDesktop';
import MyClassesViewMobile from '../my-classes/MyClassesViewMobile';

const MyClassesDesktop = () => {
  const myClasses = UseMyClasses(false);
  return <MyClassesViewDesktop myClasses={myClasses} />;
};

const MyClasses = () => {
  const { isMobile } = UseScreenSize();
  return isMobile ? <MyClassesViewMobile /> : <MyClassesDesktop />;
};

export default React.memo(MyClasses);
